import { ThunkService } from '../../services/thunkService';
import * as StM from '../../models/store';

export class EditPackageDialogActions {
    static open(id?: number): (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => void {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            dispatch({
                type: 'Dialogs/Admin/EditPackage/Open',
                id: id
            });
        };
    }

    static close(): (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => void {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            dispatch({
                type: 'Dialogs/Admin/EditPackage/Close',
            });
        };
    }

    static save(packageModel: IPackageDefinitionDto): (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => Promise<IPackageDefinitionDto> {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            return thunkService.api.admin.savePackage(packageModel);
        };
    }
}
